

export default {
  namespaced: true,
  state: {
    questions: [],
    questionsTypeList: []
  },

  mutations: {

    setQuestions(state, questions) {
      state.questions = questions;
    },
    setQuestionsTypeList(state, questionsTypeList) {
      state.questionsTypeList = questionsTypeList;
    },

  },
  actions: {
    setQuestions(context, data) {
      context.commit("setQuestions", data);
    },
    setQuestionsTypeList(context, data) {
      context.commit("setQuestionsTypeList", data);
    }
  }
};
